import { v4 as uuidv4 } from 'uuid';

function cancionesChillHop() {
  return [
    {
      id: uuidv4(),
      nombre: "Black Gospel Radio",
      portada: "https://www.radio.es/images/broadcasts/68/e7/112725/2/c300.png", 
      artista: "Radio",
      audio: "https://ice64.securenetsystems.net/BGRLIVE",
      colores: ["#FDD0BD", "#564E89"],
      reproduciendo: true 
    },
     {
      id: uuidv4(),
      nombre: "Black Diamond Gospel Hip Hop Radio",
      portada: "https://us0-cdn.onlineradiobox.com/img/l/1/97141.v1.png", 
      artista: "Radio",
      audio: "https://19293.live.streamtheworld.com/SP_R3677527_SC",
      colores: ["#FDD0BD", "#564E89"],
      reproduciendo: true 
    },
    {
      id: uuidv4(),
      nombre: "Black Soul Rhythms",
      portada: "https://static.wixstatic.com/media/1bef45_6a2a963e89184c62bb4e8c96bbe25fbd~mv2.jpg", 
      artista: "Radio",
      audio: "http://26383.live.streamtheworld.com/SAM08AAC039.mp3",
      colores: ["#FDD0BD", "#564E89"],
      reproduciendo: true 
    },
    {
      id: uuidv4(),
      nombre: "	Black Gospel Radio 365",
      portada: "https://media.live365.com/download/fffe26e6-88da-4cba-b0ae-bfb032821561.png", 
      artista: "Radio",
      audio: "https://ais-edge37-live365-dal02.cdnstream.com/a24152",
      colores: ["#FDD0BD", "#564E89"],
      reproduciendo: true 
    },
    {
      id: uuidv4(),
      nombre: "Praise 102.5",
      portada: "https://mypraiseatl.com/wp-content/uploads/sites/37/2019/05/15586209342264.png", 
      artista: "Radio",
      audio: "https://26183.live.streamtheworld.com/WPZEFMAAC.aac",
      colores: ["#FDD0BD", "#564E89"],
      reproduciendo: true 
    },
    {
      id: uuidv4(),
      nombre: "Gospel 108",
      portada: "https://cdn-profiles.tunein.com/s209962/images/logod.jpg", 
      artista: "Radio",
      audio: "http://51.161.13.49:8212/stream",
      colores: ["#FDD0BD", "#564E89"],
      reproduciendo: true 
    },
    {
      id: uuidv4(),
      nombre: "WHLQ 105.5 FM Hot Joy Radio",
      portada: "https://us0-cdn.onlineradiobox.com/img/l/3/52633.v16.png", 
      artista: "Radio",
      audio: "http://108.17.133.195/stream",
      colores: ["#FDD0BD", "#564E89"],
      reproduciendo: true 
    }
  
  ];
}

export default cancionesChillHop;
